import {
  Box,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

import CurrencyCell from "../../../component/CurrencyCell";

export default function WGRGrandTotal({ totals }) {


 // console.log("Grand Total", totals);
  const parseAmount = (value) => {
    if (value == null) return 0;

    let str = String(value).replace(/,/g, "").trim();

    // Handle trailing minus
    if (str.endsWith("-")) {
      str = "-" + str.slice(0, -1);
    }

    return Number(str) || 0;
  };


  const totalLabour = (parseAmount(totals.B) || 0);
  const totalStore = (parseAmount(totals.DirectStore) || 0) + (parseAmount(totals.OnCostStore) || 0);

  return (
    <Paper
      elevation={4}
      sx={{
        mt: 3,
        overflow: "hidden",
        border: "2px solid",
        borderColor: "success.main",
      }}
    >


      <Grid
        container
        spacing={0}
        justifyContent="center"
        alignItems="flex-start"
        sx={{ mb: 20, px: 2 }}
      >





        <Grid size={{ xs: 12, md: 12 }}>
          <TableContainer
            component={Paper}
            variant="outlined"
           
          >
            <Table size="small">
              {/* SUMMARY HEADER */}
              <TableHead>
                <TableRow>
                  {/* Empty description header */}
                  <TableCell
                    sx={{
                      bgcolor: "grey.200",
                      width: "30%",
                      border: "1px solid #999",
                    }}
                  />

                  <TableCell
                    align="center"
                    sx={{
                      fontWeight: "bold",
                      bgcolor: "grey.200",
                      fontSize: 15,
                      border: "1px solid #999",
                    }}
                  >
                    Allocation Head
                  </TableCell>

                  <TableCell
                    align="center"
                    sx={{
                      fontWeight: "bold",
                      bgcolor: "grey.200",
                      fontSize: 15,
                      border: "1px solid #999",
                    }}
                  >
                    OC/L (PU-34)
                  </TableCell>

                  <TableCell
                    align="center"
                    sx={{
                      fontWeight: "bold",
                      bgcolor: "grey.200",
                      fontSize: 15,
                      border: "1px solid #999",
                    }}
                  >
                    Distribution
                  </TableCell>

                  <TableCell
                    align="center"
                    sx={{
                      fontWeight: "bold",
                      bgcolor: "grey.200",
                      fontSize: 15,
                      border: "1px solid #999",

                    }}
                  >
                    OC/S (PU-35)
                  </TableCell>


                </TableRow>
              </TableHead>

              {/* SUMMARY BODY */}
              <TableBody>
                <TableRow>
                  <TableCell
                    rowSpan={4}
                    align="center"
                    sx={{
                      verticalAlign: "middle",
                      fontWeight: "bold",
                      border: "1px solid #999",
                    }}
                  >
                    Mechanical Department
                  </TableCell>

                  <TableCell align="center" sx={{ border: "1px solid #999" }}>
                    06-275
                  </TableCell>

                  <TableCell align="right" sx={{ border: "1px solid #999" }}>

                    <CurrencyCell value={totals.mechanical.C * .55} />
                  </TableCell>

                  <TableCell align="center" sx={{ border: "1px solid #999" }}>
                    55%
                  </TableCell>

                  <TableCell align="right" sx={{ border: "1px solid #999" }}>
                    <CurrencyCell value={totals.mechanical.D * .55} />
                  </TableCell>

                </TableRow>

                <TableRow>


                  <TableCell align="center" sx={{ border: "1px solid #999" }}>
                    06-277
                  </TableCell>

                  <TableCell align="right" sx={{ border: "1px solid #999" }}>

                    <CurrencyCell value={totals.mechanical.C * .45} />
                  </TableCell>

                  <TableCell align="center" sx={{ border: "1px solid #999" }}>
                    45%
                  </TableCell>

                  <TableCell align="right" sx={{ border: "1px solid #999" }}>
                    <CurrencyCell value={totals.mechanical.D * .45} />
                  </TableCell>

                </TableRow>

                <TableRow>


                  <TableCell align="center" sx={{ border: "1px solid #999" }}>
                    Total
                  </TableCell>

                  <TableCell align="right" sx={{ border: "1px solid #999" }}>

                    <CurrencyCell value={totals.mechanical.C} />
                  </TableCell>

                  <TableCell align="center" sx={{ border: "1px solid #999" }}>

                  </TableCell>

                  <TableCell align="right" sx={{ border: "1px solid #999" }}>
                    <CurrencyCell value={totals.mechanical.D} />
                  </TableCell>

                </TableRow>

              </TableBody>

              
            </Table>
          </TableContainer>
        </Grid>


 <Grid size={{ xs: 12, md: 12 }}>
          <TableContainer
            component={Paper}
            variant="outlined"
            sx={{
              mt: 3,
              minWidth: 450,
            }}
          >
            <Table size="small">
              {/* SUMMARY HEADER */}
              <TableHead>
                <TableRow>
                  {/* Empty description header */}
                  <TableCell
                    sx={{
                      bgcolor: "grey.200",
                      width: "30%",
                      border: "1px solid #999",
                    }}
                  />

                  <TableCell
                    align="center"
                    sx={{
                      fontWeight: "bold",
                      bgcolor: "grey.200",
                      fontSize: 15,
                      border: "1px solid #999",
                    }}
                  >
                    Allocation Head
                  </TableCell>

                  <TableCell
                    align="center"
                    sx={{
                      fontWeight: "bold",
                      bgcolor: "grey.200",
                      fontSize: 15,
                      border: "1px solid #999",
                    }}
                  >
                    OC/L (PU-34)
                  </TableCell>

                  <TableCell
                    align="center"
                    sx={{
                      fontWeight: "bold",
                      bgcolor: "grey.200",
                      fontSize: 15,
                      border: "1px solid #999",
                    }}
                  >
                    Distribution
                  </TableCell>

                  <TableCell
                    align="center"
                    sx={{
                      fontWeight: "bold",
                      bgcolor: "grey.200",
                      fontSize: 15,
                      border: "1px solid #999",

                    }}
                  >
                    OC/S (PU-35)
                  </TableCell>


                </TableRow>
              </TableHead>

              {/* SUMMARY BODY */}
              <TableBody>
                <TableRow>
                  <TableCell
                    rowSpan={4}
                    align="center"
                    sx={{
                      verticalAlign: "middle",
                      fontWeight: "bold",
                      border: "1px solid #999",
                    }}
                  >
                    Electrical Department
                  </TableCell>

                  <TableCell align="center" sx={{ border: "1px solid #999" }}>
                    06-591
                  </TableCell>

                  <TableCell align="right" sx={{ border: "1px solid #999" }}>

                    <CurrencyCell value={totals.electrical.C * .5} />
                  </TableCell>

                  <TableCell align="center" sx={{ border: "1px solid #999" }}>
                    50%
                  </TableCell>

                  <TableCell align="right" sx={{ border: "1px solid #999" }}>
                    <CurrencyCell value={totals.electrical.D * .5} />
                  </TableCell>

                </TableRow>

                <TableRow>


                  <TableCell align="center" sx={{ border: "1px solid #999" }}>
                    06-592
                  </TableCell>

                  <TableCell align="right" sx={{ border: "1px solid #999" }}>

                    <CurrencyCell value={totals.electrical.C * .5} />
                  </TableCell>

                  <TableCell align="center" sx={{ border: "1px solid #999" }}>
                    50%
                  </TableCell>

                  <TableCell align="right" sx={{ border: "1px solid #999" }}>
                    <CurrencyCell value={totals.electrical.D * .5} />
                  </TableCell>

                </TableRow>

                <TableRow>


                  <TableCell align="center" sx={{ border: "1px solid #999" }}>
                    Total
                  </TableCell>

                  <TableCell align="right" sx={{ border: "1px solid #999" }}>

                    <CurrencyCell value={totals.electrical.C} />
                  </TableCell>

                  <TableCell align="center" sx={{ border: "1px solid #999" }}>

                  </TableCell>

                  <TableCell align="right" sx={{ border: "1px solid #999" }}>
                    <CurrencyCell value={totals.electrical.D} />
                  </TableCell>

                </TableRow>

              </TableBody>

              
            </Table>
          </TableContainer>
        </Grid>

      </Grid>


    </Paper>
  );
}